<div id="print-section" class="contract">
  <div class="contract__title">
    <h1>CONTRATO PARA A PRESTAÇÃO DE SERVIÇOS DE REGULARIZAÇÃO FUNDIÁRIA</h1>
  </div>
  <div class="contract__personal-data">
    <table class="contract__table">
      <tr>
        <td>
          <p>
            Por este instrumento particular, de um lado,
            <strong>NOME:</strong> {{ proprietario?.name }},
          </p>
        </td>
      </tr>
      <tr>
        <td>
          <p>
            <strong>CPF:</strong> {{ proprietario?.cpf | mask: '000.000.000-00' }},
            <strong>RG:</strong> {{ proprietario?.rg?.number || '' }}, <strong>EMISSOR/UF: </strong>
            {{ proprietario?.rg?.issuer || '' }}/{{ proprietario?.rg?.state || ''}}
          </p>
        </td>
      </tr>
      <tr *ngIf="(proprietario?.maritalStatus === estadoCivil.MARRIED) && conjuge ">
        <td>
          <p>
            <strong>CÔNJUGE/COMPANHEIRO:</strong> {{ conjuge?.name }},
            <strong>CPF:</strong> {{ conjuge?.cpf | mask: '000.000.000-00' }}
          </p>
        </td>
      </tr>
      <tr *ngIf="cadastro?.reurbModalidade">
        <td>
          <p>
            <strong>Condições REURB:</strong> Renda Familiar menor que 5(cinco) salários mínimos
            e não ter sido beneficiado pela REURB anteriormente. <br />
            ( {{ cadastro.reurbModalidade === reurbModalidade.REURB_S ? 'X' : '' }} ) REURB–S ou
            ( {{ cadastro.reurbModalidade === reurbModalidade.REURB_E ? 'X' : '' }} ) REURB–E
          </p>
        </td>
      </tr>
      <tr>
        <td>
          <p>
            <strong>Qual o segmento de uso do imóvel:</strong>
            ( {{ imovel?.usage === imovelTipo.RESIDENTIAL ? 'X' : '' }} ) Residencial
            ( {{ imovel?.usage === imovelTipo.COMMERCIAL ? 'X' : '' }} ) Comercial
            ( {{ imovel?.usage === imovelTipo.MIXED ? 'X' : '' }} ) Misto
          </p>
        </td>
      </tr>
      <tr>
        <td>
          <p>
            <strong>Estado Civil:</strong>
            ( {{ proprietario?.maritalStatus === estadoCivil.MARRIED ? 'X' : '' }} ) Casado(a)
            ( {{ proprietario?.maritalStatus === estadoCivil.SINGLE ? 'X' : '' }} ) Solteiro(a)
            ( {{ proprietario?.maritalStatus === estadoCivil.WIDOWED ? 'X' : '' }} ) Viúvo(a)
            ( {{ proprietario?.maritalStatus === estadoCivil.SEPARATED ? 'X' : '' }} ) Separado(a)
          </p>
        </td>
      </tr>
      <tr>
        <td>
          <p>
            <strong>E-mail: </strong> {{ proprietario?.email }}
            <strong>Telefone: </strong>
            {{ proprietario?.phones?.cellphone ? (proprietario.phones.cellphone | mask: '(00) 00000-0000') : ''}}
          </p>
        </td>
      </tr>
      <tr>
        <td>
          <p>
            <strong>Observações (situação jurídica, endereço, quadra e lote): </strong>
          </p>
        </td>
      </tr>
    </table>

    <p>Doravante denominados <strong>"{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}"</strong>; e, de outro lado,
      <strong>SPE VILA PRUDENTE B REGULARIZAÇÃO FUNDIÁRIA LTDA.</strong>, pessoa jurídica de direito
      privado, com SEDE na Rua Cláudio Soares 72, conj. 615 Pinheiros, São Paulo – SP, inscrita no CNPJ/MF, sob o nº
      <strong>62.619.555/0001-73</strong>, neste ato representada de acordo com seus atos constitutivos, doravante
      denominado <strong>"CONTRATADA"</strong>, e, em conjunto com {{ conjuge ? 'os' : 'o' }}
      <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>, estando em conformidade
      com o Art. 54 da Lei Federal nº 8078/90, aderem de forma integral ao presente <strong>CONTRATO DE PRESTAÇÃO DE
        SERVIÇOS DE REGULARIZAÇÃO FUNDIÁRIA</strong>, regido pelas seguintes cláusulas e anexos. Os serviços estão
      descritos no <strong>“anexo I”</strong>, que faz parte deste Contrato.
    </p>
  </div>

  <div class="clause">
    <h2>Cláusula Primeira – OBJETO</h2>

    <p>
      <strong>1.1.</strong> Este Contrato estabelece as condições pelas quais a <strong>CONTRATADA</strong> prestará
      serviços de regularização fundiária “REURB”, visando realizar os procedimentos necessários para regularização do
      núcleo urbano informal no qual está situado o imóvel {{ conjuge ? 'dos' : 'do' }}
      <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong> e para obtenção da titulação da unidade
      imobiliária da qual {{ conjuge ? 'os' : 'o' }} <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>
      detém a posse, nos termos da Lei Federal 13.465/17, regulamentada pelo Decreto Federal n° 9.310/2018, conforme
      previsto no Edital de Chamamento Público nº 003/2024 da CDHU e no Termo de Parceria firmado entre a
      <strong>CONTRATADA</strong> e a
      Associação de Moradores que representa o núcleo objeto da regularização.
    </p>

    <p>
      <strong>1.2.</strong> A execução das atividades objeto deste contrato fica condicionada à adesão mínima de 60%
      (sessenta por cento) dos moradores da comunidade, conforme estabelecido no Edital de Chamamento Público nº
      003/2024 da CDHU e no Termo de Parceria firmado entre a <strong>CONTRATADA</strong> e a Associação de Moradores.
    </p>
    <p>
      <strong>1.3.</strong> Caso a adesão mínima não seja atingida dentro do prazo máximo de 3 (três) meses ou até a
      ETAPA – ELABORAÇÃO DOS PROJETOS e a <strong>CONTRATADA</strong> opte por não realizar as atividades, poderá
      ocorrer a rescisão deste Contrato, com a devolução dos valores pagos {{ conjuge ? 'aos' : 'ao' }}
      <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>, da mesma forma com que foram recebidos,
      descontado o custo relativo ao boleto bancário e o valor correspondente à 15% (quinze por cento) dos valores pagos
      de entrada, para cobrir as despesas administrativas havidas até então.
    </p>
  </div>

  <div class="clause">
    <h2>Cláusula Segunda – RESPONSABILIDADE DAS PARTES</h2>
    <p><strong>2.1.</strong> São obrigações {{ conjuge ? 'dos' : 'do' }}
      <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>
      efetuar o pagamento na forma da Cláusula Terceira e fornecer todas as informações e documentos solicitados pela
      <strong>CONTRATADA</strong> na execução dos Serviços.
    </p>
    <p>
      <strong>2.2.</strong> {{ conjuge ? 'Os' : 'O' }} <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>
      {{ conjuge ? 'comprometem-se' : 'compromete-se' }} a apresentar à <strong>CONTRATADA</strong> no prazo de até
      <strong>15 dias corridos</strong> todos e quaisquer documentos que forem solicitados, incluindo assinaturas em
      documentos, declarações e procurações, sob pena de não ser incluído nas listagens a serem enviadas para o CDHU.
    </p>
    <p>
      <strong>2.3.</strong> São obrigações da <strong>CONTRATADA</strong> a execução dos Serviços constantes no Anexo 1
      (escopo do serviço) os quais serão elaborados em conformidade com as Diretrizes Técnicas contidas no Anexo II do
      Edital de Chamamento Público nº 003/2024 da CDHU.
    </p>
    <p>
      <strong>2.4.</strong> As partes declaram ter o conhecimento do inteiro teor e comprometem-se mutuamente com as
      condições previstas no Edital de Chamamento Público nº 003/2024 da CDHU, na Lei Federal nº 13.465/17 e Termo de
      Parceria firmado entre a <strong>CONTRATADA</strong> e a Associação de Moradores que representa o núcleo objeto da
      regularização.
    </p>
  </div>

  <div class="clause">
    <h2>
      Cláusula Terceira – REMUNERAÇÃO E FORMA DE PAGAMENTO
    </h2>
    <p><strong>3.1.</strong>Pela prestação dos Serviços objeto deste Contrato, {{ conjuge ? 'os' : 'o' }} <strong>{{
        conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong> {{ conjuge ? 'pagarão' : 'pagará' }} no boleto bancário
      <ng-container *ngIf="pagamentoAVista; else pagamentoAPrazoTemplate">
        à vista o valor de {{ cadastro.valorContrato | currency: 'BRL'}}
        ({{cadastro.valorContrato | numeroExtenso: numeroExtensoTipo.MONETARIO}})
      </ng-container>
      <ng-template #pagamentoAPrazoTemplate>
        em {{ cadastro.totalParcelas }} parcelas iguais de {{ cadastro.valorParcela | currency: 'BRL'}}
        ({{cadastro.valorParcela | numeroExtenso: numeroExtensoTipo.MONETARIO}})
      </ng-template>
    </p>

    <p>
      <strong>3.2.</strong> Os direitos reais a serem atribuídos {{ conjuge ? 'aos' : 'ao' }}
      <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>, estarão definidos na
      Certidão de Regularização Fundiária, a ser expedida pela CDHU. Para ser beneficiário dos citados direitos e
      receber a titulação de sua unidade imobiliária, o nome e a unidade imobiliária {{ conjuge ? 'dos' : 'do' }}
      <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong> deverão constar na CRF, tudo em conformidade com o
      artigo 41 e incisos da Lei 13.465/17. Assim sendo, {{ conjuge ? 'ficam os' : 'fica o' }}
      <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong> {{ conjuge ? 'cientes' : 'ciente' }} ciente de
      que, tanto seu nome como a descrição de sua unidade imobiliária, somente constarão da CRF com a quitação integral
      do preço pactuado. Com fulcro no parágrafo primeiro do artigo 14, da Lei 13.465/17, e no Edital de Chamamento
      Público nº 003/2024 da CDHU, a <strong>CONTRATADA</strong> entregará, para a CDHU, todos os projetos necessários e
      previstos nos artigos 35 e 36 da mesma lei, acompanhada da lista dos ocupantes de cada unidade imobiliária;
      memorial descritivo de cada unidade e demais projetos de topografia e engenharia mencionados no <strong>“anexo
        I”</strong>.
    </p>
    <p>
      <strong>3.3.</strong> Havendo impontualidade no cumprimento da obrigação {{ conjuge ? ' pelos' : ' pelo' }}
      <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>, este incorrerá em multa de 2% (dois por cento)
      sobre o valor em atraso corrigido e juros moratórios de 1% (um por cento) ao mês, sob o valor devido.
    </p>

    <p>
      <strong>3.4.</strong> As parcelas serão reajustadas anualmente, a cada 12 (doze) meses a partir da assinatura
      deste contrato, pelo Índice Nacional de Preços ao Consumidor Amplo (<strong>IPCA</strong>), divulgado pelo
      Instituto Brasileiro de Geografia e Estatística (IBGE).
    </p>
    <p>
      <strong>3.5.</strong> Caso o IPCA seja extinto ou haja mudança na metodologia de cálculo que o torne impraticável,
      as partes concordam em substituí-lo por outro índice oficial que melhor reflita a inflação, como o Índice Geral de
      Preços do Mercado (IGP-M) da Fundação Getúlio Vargas (FGV), ou outro índice que venha a substituí-lo por
      determinação legal.
    </p>

    <p>
      <strong>3.6.</strong> O valor estabelecido na Cláusula 3.1. refere-se apenas e tão somente aos projetos de
      topografia e engenharia mencionados no <strong>“anexo I”</strong>, bem como, assistência jurídica provenientes dos
      trabalhos técnicos apresentados, NÃO abrangendo, portanto, Obras de Infraestrutura Essenciais, previstas no §1º do
      artigo 36 da Lei Federal nº 13.465/17, ou as que eventualmente a CDHU aponte como sendo necessárias para a emissão
      da CRF.
    </p>

    <ng-container *ngIf="cadastro.superSocial">

      <p>
        <strong>3.7.</strong> O valor e a forma de pagamento diferenciados estabelecidos na Cláusula 3.1. integram o
        programa “Super
        Social” promovido por iniciativa do INSTITUTO CAMPEÃO, cuja adesão será confirmada através de comprovação de
        renda, que considerará a renda total de todos os moradores da unidade a ser regularizada.
      </p>

      <p>
        <strong>3.8.</strong> Para ingresso no referido programa o CONTRATANTE se compromete a apresentar os
        comprovantes de renda de todos os que residem na unidade imobiliária durante a FASE – CADASTRO SOCIOECONÔMICO
        DAS FAMÍLIAS. A comprovação de renda passará por um Comitê formado por representantes da
        <strong>CONTRATADA</strong>, INSTITUTO
        CAMPEÃO e da ASSOCIAÇÃO DE MORADORES, cujo resultado será fornecido através de um laudo socioeconômico que será
        obrigatoriamente assinado pelo CONTRATANTE no prazo máximo de até 5 dias após a comunicação.
      </p>

      <p>
        <strong>3.9.</strong> Em caso de deferimento para adesão do CONTRATANTE ao programa “Super Social”, a assinatura
        do laudo acarretará a emissão dos boletos conforme o parcelamento previsto na Cláusula 3.1.
      </p>

      <p>
        <strong>3.10.</strong> O indeferimento por parte do Comitê, torna ineficaz o presente instrumento e o
        CONTRATANTE
        será automaticamente removido do programa, podendo:
      </p>
      <ul>
        <li>
          <strong>3.10.1.</strong> rescindir o presente instrumento; ou
        </li>
        <li>
          <strong>3.10.2.</strong> assinar um novo contrato com a tabela de preços padrão do núcleo a ser regularizado,
          sendo que o valor pago à titulo de entrada será transferido para o novo contrato assinado.
        </li>
      </ul>

      <p>
        <strong>3.11.</strong> Havendo discordância com o laudo emitido pelo Comitê, o CONTRANTE poderá em até 5 dias
        após a assinatura do
        laudo, apresentar documentos adicionais para reiterar o seu pedido. Da nova análise do Comitê NÃO caberá
        recurso.
      </p>

      <p>
        <strong>3.12.</strong> Em caso de rescisão, seja por não enquadramento ao programa “Super Social”, seja por
        discordância da decisão
        do Comitê, a parte ideal correspondente a 50% (cinquenta por cento) dos valores eventualmente pagos serão
        retidos
        como forma de suportar as despesas administrativas para emissão do presente contrato.
      </p>

      <p>
        <strong>3.13.</strong> Em qualquer uma das hipóteses a ausência de assinatura do CONTRATANTE no laudo
        socioeconômico
        impossibilitará seu ingresso na lista de beneficiários a ser encaminhada ao CDHU.
      </p>

      <p>
        <strong>3.14.</strong> Os benefícios do programa “Super Social” do INSTITUTO CAMPEÃO possuem caráter
        personalíssimo e, portanto,
        NÃO comportam cessão em caso de transferência da unidade imobiliária.
      </p>
    </ng-container>
  </div>

  <div class="clause">
    <h2>Cláusula Quarta – DOS DIREITOS AUTORAIS</h2>
    <p>{{ conjuge ? 'Ficam os' : 'Fica o' }} <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>
      {{ conjuge ? 'cientes' : 'ciente' }} de que todos os projetos técnicos que serão apresentados para a CDHU, são de
      uso exclusivo da <strong>CONTRATADA</strong>, a qual detém os direitos autorais sobre eles.
    </p>
  </div>

  <div class="clause">
    <h2>Cláusula Quinta – DOS PRAZOS E OUTRAS CONDIÇÕES</h2>
    <p>
      <strong>5.1.</strong> O Presente Contrato se refere exclusivamente ao serviço de regularização fundiária na esfera
      administrativa, tanto na CDHU como no Cartório de Registro de Imóveis.
    </p>
    <p>
      <strong>5.2.</strong> A vigência do presente contrato é condicionada ao pagamento do valor previsto nele, da
      realização das Obras de Infraestrutura indicadas pela CDHU, e da conclusão do projeto de regularização fundiária,
      encerrando-se com a efetiva abertura de matrícula do imóvel no nome {{ conjuge ? ' dos' : ' do' }}
      <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong> ou no caso de necessidade de reassentamento, com a
      aprovação do Plano de Realocação por parte da CDHU.
    </p>
    <p>
      <strong>5.3.</strong> {{ conjuge ? 'Os' : 'O' }} <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>
      {{ conjuge ? 'poderão' : 'poderá' }} contratar, ao final do processo de regularização fundiária, os serviços
      relativos à averbação da construção, cujas especificações, valores e emolumentos serão objeto de aditamento ao
      presente contrato.
    </p>
    <p>
      <strong>5.4.</strong> Considerando que o processo de regularização fundiária deve demonstrar a realidade fática
      dos imóveis, todas as medições realizadas pela equipe técnica serão realizadas em conformidade com a realidade aos
      qual os imóveis se encontram, mesmo que a descrição, perímetro, áreas e construção estejam divergentes com os
      contratos de aquisição apresentados {{ conjuge ? ' pelos' : ' pelo' }}
      <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>.

    </p>
    <p>
      <strong>5.5.</strong> Antes da apresentação dos documentos para emissão da CRF, será enviada através da plataforma
      “Voce Pode Regularizar” ou por meio eletrônico (e-mail ou WhatsApp) para conhecimento a denominada “planta de
      anuência”, devidamente acompanhada de memorial descritivo, que conterá as medidas individuais apuradas in loco do
      lote do CONTRATANTE. Havendo discordância com as medidas apresentadas a contestação deverá ser apresentada em 15
      dias corridos. A ausência de manifestação acarretará em concordância com as medidas apresentadas.
    </p>
    <p>
      <strong>5.6.</strong> Em caso de venda da unidade imobiliária a terceiros, {{ conjuge ? 'os' : 'o' }}
      <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>
      {{ conjuge ? 'se responsabilizam' : 'se responsabiliza' }} a informar imediatamente à <strong>CONTRATADA</strong>
      para a devida formalização do instrumento particular de cessão dos direitos e obrigações aqui formalizados. A
      <strong>CONTRATADA</strong> não se responsabilizará por erro referente à titulação da unidade decorrente da
      ausência da mencionada comunicação.
    </p>

    <p>
      <strong>5.7.</strong> Não estão contempladas neste contrato, despesas com tributos inerentes à unidade
      imobiliária, taxas/preços públicos municipais e emolumentos de cartórios.
    </p>

    <p>
      <strong>5.8.</strong> Não estão contemplados neste contrato, eventuais procedimentos judiciais que sejam
      necessários para a viabilização da regularização.
    </p>
  </div>

  <div class="clause">
    <h2>Cláusula Sexta – RESCISÃO</h2>
    <p>
      <strong>6.1.</strong> Este Contrato poderá ser rescindido imotivadamente {{ conjuge ? 'pelos' : 'pelo' }}
      <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>, desde que seja enviada
      notificação prévia, com <strong><u>antecedência mínima de 15 (quinze) dias</u></strong>, gerando as seguintes
      consequências:
    </p>
    <ul>
      <li>
        <strong>6.1.1.</strong> Se o requerimento de REURB já estiver protocolado junto à CDHU:
        <ul>
          <li>
            <strong>6.1.1.</strong> Devolução de 80% do valor pago caso o protocolo tenha sido realizado sem qualquer
            documento que o acompanhe, sendo retido o percentual de 10% inerente ao início dos estudos técnicos e
            despesas administrativas;
          </li>
          <li>
            <strong>6.1.2.</strong> Devolução de 70% do valor pago se já elaborada a planta e memorial do perímetro do
            núcleo a ser regularizado, providência que demanda estudo fundiário específico;
          </li>
          <li>
            <strong>6.1.3.</strong> Devolução de 50% do valor pago se já elaborado , além da planta e memorial do
            perímetro, o Levantamento Planialtimétrico Cadastral do Núcleo;
          </li>
          <li>
            <strong>6.1.4.</strong> Devolução de 30% do valor pago se já elaborado, além das peças citadas no item
            anterior, o Projeto Urbanístico do núcleo;
          </li>
        </ul>
      </li>

      <li>
        <strong>6.1.2.</strong> Se o requerimento de REURB ainda não estiver protocolado junto à CDHU:
        <ul>
          <li>
            <strong>6.2.1.</strong> Devolução de 90% do valor pago inerente ao início dos estudos técnicos e despesas
            administrativas;
          </li>
          <li>
            <strong>6.2.2.</strong> Devolução de 70% do valor pago se já elaborada a planta e memorial do perímetro do
            núcleo a ser regularizado, providência que demanda estudo fundiário específico;
          </li>
          <li>
            <strong>6.2.3.</strong> Devolução de 50% do valor pago se já elaborado , além da planta e memorial do
            perímetro, o Levantamento Planialtimétrico Cadastral do Núcleo;
          </li>
          <li>
            <strong>6.2.4.</strong> Devolução de 30% do valor pago se já elaborado, além das peças citadas no item
            anterior, o Projeto Urbanístico do núcleo;

          </li>
        </ul>
      </li>
    </ul>

    <p>
      <strong>6.2.</strong> No caso de rescisão por motivo de indeferimento do processo administrativo de REURB pela
      CDHU, <strong>por fato não atribuível à CONTRATADA,</strong> não haverá a restituição de nenhum dos valores
      pagos até o momento do indeferimento. A mesma condição se aplica em caso da negativa de registro do projeto de
      regularização fundiária por parte do Cartório de Registro de Imóveis, por fato também não atribuível à
      <strong>CONTRATADA</strong>.
    </p>
  </div>

  <div class="clause">
    <h2>Cláusula Sétima – DISPOSIÇÕES GERAIS</h2>
    <p>
      <strong>7.1.</strong> A CONTRATADA poderá ceder o recebível para instituições financeiras, bem como os direitos e
      obrigações decorrentes deste instrumento.
    </p>
    <p>
      <strong>7.2.</strong> Nenhuma das Partes poderá ser considerada como inadimplente de suas obrigações contratuais
      se tal fato for resultante de caso fortuito ou força maior.
    </p>
    <p>
      <strong>7.3.</strong> As Partes se obrigam por si, seus herdeiros e sucessores a qualquer título e, ao fiel
      cumprimento deste Contrato.
    </p>
    <p>
      <strong>7.4.</strong> {{ conjuge ? 'os' : 'o' }} <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>
      autoriza, de maneira gratuita e por tempo indeterminado, o uso de sua imagem e voz para eventuais campanhas
      publicitárias da <strong>CONTRATADA</strong>, que poderão ser veiculadas por qualquer modalidade (mídias
      tradicionais ou digitais).
    </p>
    <p>
      <strong>7.5.</strong> {{ conjuge ? 'os' : 'o' }} <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>
      subscreve, neste ato, Termo de Concordância expressa de alienação fiduciária de seu imóvel para garantia de
      pagamento das obrigações pecuniárias deste contrato, na forma do Anexo II.

    </p>
    <p>
      <strong>7.6.</strong> As obrigações aqui pactuadas ficam condicionadas ao pagamento do valor integral pactuado na
      Cláusula Terceira.
    </p>
  </div>

  <div class="clause">
    <h2>Cláusula Oitava – FORO E ASSINATURA</h2>
    <p>
      <strong>8.1.</strong> Para dirimir quaisquer controvérsias oriundas deste Contrato, as Partes elegem o Foro da
      Comarca de São Paulo, Estado de São Paulo.
    </p>
    <p>
      <strong>8.2.</strong> As <strong>PARTES</strong>, de forma irrevogável e irretratável, afirmam e declaram que o
      presente instrumento poderá ser assinado eletronicamente mediante: (i) impressão, assinatura e digitalização e
      reenvio deste termo; (ii) envio de código por e-mail cadastrado; (iii) envio de código por mensagem de celular ou
      Whatsapp cadastrado; ou (iv) envio de foto segurando o documento pessoal. Seja qual for a forma escolhida
      {{ conjuge ? 'pelos' : 'pelo' }} <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>, as
      <strong>PARTES</strong> a consideram válida e aceita, com fundamento no art. 10º, §2º da MP 2200-2/2001, e do art.
      6º do Decreto 10.278/2020, sendo a forma que for, as assinaturas serão consideradas válidas, vinculantes e
      executáveis, desde que firmadas pelos representantes legais das <strong>PARTES</strong>.
    </p>
    <p>
      E, por estarem assim, justas e contratadas, firmam o presente Contrato em 2 (duas) vias de igual teor e forma, na
      na presença das testemunhas abaixo, para que produza seus regulares efeitos de direito.
    </p>

    <p>{{ cadastro?.projetoMunicipio }}, {{ cadastro?.contractDate | date: 'longDate'}}.</p>
  </div>

  <div class="contract__subscription" *ngIf="isPrint">
    <div class="contract__subscription__table">
      <div class="contract__subscription__column">
        <p>______________________________________________</p>
        <p>CONTRATANTE/OUTORGANTE</p>
        <div class="contract__subscription__column__infos">
          <p>Representante: {{ proprietario?.name }}</p>
          <p>CPF: {{ proprietario?.cpf }}</p>
        </div>
      </div>
      <div class="contract__subscription__column contract__subscription__column--no-border-left">
        <img class="contract__ceo-subscription" alt="Assinatura CEO" src="/assets/images/assinatura.svg" />
        <p>______________________________________________</p>
        <p>SPE VILA PRUDENTE B REGULARIZAÇÃO FUNDIÁRIA LTDA</p>
        <div class="contract__subscription__column__infos">
          <p>Representante: NATHALIE ROMANO</p>
          <p>CNPJ: 62.619.555/0001-73</p>
        </div>
      </div>
      <div class="contract__subscription__column contract__subscription__column--no-border-top">
        <p>______________________________________________</p>
        <div class="contract__subscription__column__infos">
          <p>Testemunha 1: _______________________________</p>
          <p>CPF:</p>
        </div>
      </div>

      <div class="contract__subscription__column contract__subscription__column--no-border-top">
        <p>______________________________________________</p>
        <div class="contract__subscription__column__infos">
          <p>Testemunha 2: _______________________________</p>
          <p>CPF:</p>
        </div>
      </div>
    </div>
  </div>

  <div class="anexo">
    <h2>ANEXO I</h2>
    <h3>ESCOPO DO SERVIÇO</h3>
    <p>
      <strong>1.</strong>Os serviços da CONTRATADA incluem:
    </p>
    <ul>
      <li><strong>a.</strong> Elaboração do Plano de Trabalho previsto no item 5.3.1 do Edital de Chamamento n° 003/2024
        da CDHU;</li>
      <li><strong>b.</strong> Execução de levantamento planialtimétrico georreferenciado da área;</li>
      <li><strong>c.</strong> Elaboração da planta e memorial descritivo da área; </li>
      <li><strong>d.</strong> Cadastro socioeconômico das famílias;
      </li>
      <li><strong>e.</strong> Elaboração do projeto urbanístico;
      </li>
      <li><strong>f.</strong> Estudo técnico ambiental;
      </li>
      <li><strong>g.</strong> Assessoria técnica na interlocução com órgãos públicos;
      </li>
      <li><strong>h.</strong> Elaboração dos projetos executivos de obras de infraestrutura essencial;</li>
      <li><strong>i.</strong> Elaboração de estudo de definição de realocações necessárias em virtude de ocupações em
        áreas de risco e/ou preservação permanente;
      </li>
      <li><strong>j.</strong> Elaboração dos termos de compromisso para a execução das obras de infraestrutura
        essencial; </li>
      <li><strong>k.</strong> Acompanhamento até a emissão da Certidão de Regularização Fundiária (CRF) em nome do
        CONTRATANTE;</li>
      <li><strong>l.</strong> Registro da referida CRF junto ao Cartório de Registro de Imóveis competente;
      </li>
      <li><strong>m.</strong> Acompanhamento da titulação do CONTRATANTE desde que cumpra integralmente com suas
        obrigações previstas neste Contrato.
      </li>
    </ul>
    <p><strong>2.</strong> Estão <strong>EXCLUÍDOS</strong> do escopo deste Contrato:</p>
    <ul>
      <li><strong>a.</strong> Execução de obras de infraestrutura essencial ou urbanização adicional;
      </li>
      <li><strong>b.</strong> Gestão ou custeio de indenização a terceiros;
      </li>
      <li><strong>c.</strong> Defesa ou propositura de ações judiciais relativas ao imóvel objeto deste Contrato.</li>
    </ul>
    <p>
      <strong>3.</strong> A execução das obras de infraestrutura essencial e a realocação de famílias, <strong> estão
        excluídas do escopo deste Contrato</strong>, serão de responsabilidade exclusiva dos beneficiários conforme
      previsto no item 5.3.4 do EDITAL.Portanto, fazem parte do escopo deste contrato apenas a realização dos estudos
      necessários para identificar as obras de infraestrutura essenciais pendentes ou àquelas que o CDHU entenda como
      sendo necessárias, bem como o estudo a respeito das realocações que serão necessárias para a conclusão da REURB.
    </p>

    <p>
      <strong>4.</strong> Os estudos mencionados no item anterior definirão os custos totais envolvidos e serão
      calculados de forma a definir um valor unitário para cada unidade/lote dentro do perímetro da REURB.
    </p>

    <p>
      <strong>5.</strong> Após a execução do Plano de Trabalho e a aprovação dele pela CDHU, a ASSOCIAÇÃO, assessorada
      pela <strong>CONTRATADA</strong>, iniciará o processo de captação de recursos financeiros junto a investidores
      privados, ou provenientes de emendas parlamentares, ou de outros órgãos ou entidades do governo federal,
      estadual ou municipal,
      com vistas a diminuir ou evitar a necessidade de captação adicional de recursos dos beneficiários para a
      realização das obras e dos serviços relacionados no item 5.3.4 do Edital de Chamamento n° 003/2024 da CDHU.
    </p>

    <p>
      <strong>6.</strong> A atividade prevista no item “k” deste anexo, está condicionada ao cumprimento, pela
      CONTRATANTE, do disposto no item 5.
    </p>
  </div>

  <div class="anexo">
    <h2>ANEXO II</h2>
    <h3>TERMO DE CONCORDÂNCIA EXPRESSA DE ALIENAÇÃO FIDUCIÁRIA</h3>
    <p>
      CREDOR FIDUCIANTE: USU CAMPEÃO INCORPORAÇÃO, LOTEAMENTO E URBANIZAÇÃO SOCIAL LTDA.
    </p>
    <p>
      DEVEDOR FIDUCIÁRIO: {{ proprietario?.name }}
    </p>

    <p>IMOVEL: Lote: {{ cadastro?.lote}}, cuja matrícula individual será aberta após registro da Certidão de
      Regularização Fundiária, a
      ser expedida ao final do processo administrativo de REURB que tramitará na CDHU.</p>

    <p>
      Pelo presente Termo o DEVEDOR FIDUCIÁRIO se compromete a alienar em garantia de cumprimento das obrigações
      pecuniárias contraídas em contrato de prestação de serviços do qual este Termo se constitui como Anexo, o imóvel
      acima discriminado, em favor do CREDOR FIDUCIANTE ou a favor de quem o mesmo indicar .
      <br>
      O DEVEDOR FIDUCIÁRIO também se compromete a assinar qualquer documento necessário para a consecução da garantia
      prevista neste Termo, caso venha a ser exibido esse novo documento pela Prefeitura ou pelo Oficial de Registro de
      Imóveis. A recusa em celebrar ou assinar esse novo documento importará na aplicação das seguintes sanções:
      ****
    </p>
    <p>
      O DEVEDOR FIDUCIÁRIO declara, desde já, que a Alienação fiduciária aqui tratada pode ser inserida no teor da
      Certidão de Regularização Fundiária, na forma da lei 13.465/17 para que surta seus efeitos legais
    </p>

    <p>{{ cadastro?.projetoMunicipio }}, {{ cadastro?.contractDate | date: 'longDate'}}.</p>

    <div class="contract__subscription" *ngIf="isPrint">
      <div class="contract__subscription__table">
        <div class="contract__subscription__column">
          <p>______________________________________________</p>
          <p>CONTRATANTE/OUTORGANTE</p>
          <div class="contract__subscription__column__infos">
            <p>Representante: {{ proprietario?.name }}</p>
            <p>CPF: {{ proprietario?.cpf }}</p>
          </div>
        </div>
        <div class="contract__subscription__column contract__subscription__column--no-border-left">
          <img class="contract__ceo-subscription" alt="Assinatura CEO" src="/assets/images/assinatura.svg" />
          <p>______________________________________________</p>
          <p>SPE VILA PRUDENTE B REGULARIZAÇÃO FUNDIÁRIA LTDA</p>
          <div class="contract__subscription__column__infos">
            <p>Representante: NATHALIE ROMANO</p>
            <p>CNPJ: 62.619.555/0001-73</p>
          </div>
        </div>
        <div class="contract__subscription__column contract__subscription__column--no-border-top">
          <p>______________________________________________</p>
          <div class="contract__subscription__column__infos">
            <p>Testemunha 1: _______________________________</p>
            <p>CPF:</p>
          </div>
        </div>

        <div class="contract__subscription__column contract__subscription__column--no-border-top">
          <p>______________________________________________</p>
          <div class="contract__subscription__column__infos">
            <p>Testemunha 2: _______________________________</p>
            <p>CPF:</p>
          </div>
        </div>
      </div>
    </div>
  </div>